/**
 * Per-platform serializer registry.
 *
 * Each entry takes canonical HTML (or plain text — the serializer is
 * tolerant of both) and returns:
 *   { text, char_count, char_cap, warnings, errors }
 *
 * `text` is what gets sent to the platform; `char_count` is what the
 * editor's footer counter displays. `errors` block publish (e.g. cap
 * exceeded); `warnings` are advisory and shown in the preview panel.
 */

import { serializeForLinkedIn } from './linkedin.js';
import { serializeForSubstack } from './substack.js';

export const SERIALIZERS = {
    linkedin: serializeForLinkedIn,
    substack: serializeForSubstack,
    // Voice context has no platform serialization — the editor uses a
    // word counter and skips the preview pipeline. instagram / x land
    // in Phase 3 / 4.
};

export function serializeFor(platform, html) {
    const fn = SERIALIZERS[platform];
    if (!fn) {
        // Unknown platform — pass through, no warnings.
        return {
            text: String(html || ''),
            char_count: String(html || '').length,
            char_cap: 0,
            warnings: [],
            errors: [],
        };
    }
    return fn(html);
}
